/**
 * The base64url VAPID key as the push subscription API wants it.
 *
 * Shared since §9.786: the customer app subscribes a customer's browser and the courier's app a courier's phone,
 * against the same server key, and one decoding of it is what keeps the two from disagreeing about a byte.
 */
export function vapidKeyBytes(publicKey: string): Uint8Array {
  const padded = publicKey + '='.repeat((4 - (publicKey.length % 4)) % 4)
  const base64 = padded.replace(/-/g, '+').replace(/_/g, '/')
  const raw = atob(base64)
  const bytes = new Uint8Array(raw.length)
  for (let index = 0; index < raw.length; index += 1) bytes[index] = raw.charCodeAt(index)
  return bytes
}
